import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import "./styles/App.css";
import Library from "./components/pages/Library";
import Constructor from "./components/pages/Constructor";
import Profile from "./components/pages/Profile";
import AnimatedCursor from "react-animated-cursor";
import Footer from "./components/Footer";
import Schedule from "./components/pages/Schedule";
import Shop from "./components/pages/Shop";
import About from "./components/pages/About";
import { useEffect, useState } from "react";
import ChatbotModal from "./components/Chatbot";
import { ChatbotTrans } from "./utils/translations";
import { useAppContext } from "./context/AppContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import Callback from "./components/Callback";
import { useAuth0 } from "@auth0/auth0-react";
import { getUser } from "./services/userService";
import Toaster from "./components/Toaster";
import SavedPractices from "./components/pages/SavedPractices";
import Offline from "./components/pages/Offline";
import ReactGA from "react-ga4";
import Blog from "./components/pages/Blog";
import BlogPostPage from "./components/BlogPostPage";
import { initFacebookPixel, trackPixelEvent } from "./utils/pixel";
import LandingPage from "./components/pages/Landing";
import OnlineClubPage from "./components/pages/OnlineClub";
import Live from "./components/pages/Live";
import Loader from "./components/Loader";
import SuccessfulPayment from "./components/pages/SuccessfulPayment";
import Subscribe from "./components/pages/Subscribe";
import UnsubscribeSuccess from "./components/pages/UnsubscribeSuccess";
import MembersOnly from "./components/pages/MemberOnly";
const TRACKING_ID = "G-QKNDY186TQ";
ReactGA.initialize(TRACKING_ID);

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { language, setUser, user, setToken, toaster, setToaster, loading, setLoading } = useAppContext();
  const { isAuthenticated, user: auth0user, getAccessTokenSilently, isLoading: authLoading, } = useAuth0();
  usePageTracking();

  //todo more logging
  // const handleButtonClick = () => {
  //   ReactGA.event({
  //     category: "User",
  //     action: "Clicked Sign Up Button",
  //     label: "Homepage Signup"
  //   });
  // };
  
  // <button onClick={handleButtonClick}>Sign Up</button>
  
  useEffect(() => {
    if (user) {
      console.log(user)
    }
  }, [user])

  useEffect(() => {
    initFacebookPixel();
    // Подключение Pixel если его еще нет
    if (!window.fbq) return;
  
    // Скролл до 90%
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
  
      if (scrollPercent >= 90 && !window.__scrollTracked) {
        window.fbq('trackCustom', 'Scrolled90');
        window.__scrollTracked = true;
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // console.log("Authenticated:", isAuthenticated);
  // console.log("User auth 0:", auth0user);
  
  useEffect(() => {
    // 1) Wait until Auth0 is done initializing
    if (authLoading) return;

    // 2) If we’re authenticated but haven’t fetched our app-user yet → fetch them
    if (isAuthenticated && !user) {
      ;(async () => {
        try {
          const token = await getAccessTokenSilently({
            audience: "https://onceuponamat.com/api/v2/"
          });
          const appUser = await getUser(token);
          setToken(token);
          setUser(appUser);
          trackPixelEvent("Login")
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      // either not authenticated, or we already have `user` → we’re done
      setLoading(false);
    }
  }, [authLoading, isAuthenticated, auth0user, user]);

 
  return (
    <div className="App">
      <AnimatedCursor
        innerSize={8}
        outerSize={20}
        color="198, 188, 180"
        outerAlpha={0.2}
        innerScale={0.000001}
        outerScale={4}
        showSystemCursor={true}
        clickables={[
          "a",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
        ]}
      />
      {authLoading || loading && <Loader loading={authLoading || loading}/>}
      <Header />
      <Routes>
        <Route path="/library" element={<Library />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/offline" element={<Offline />} />
        <Route path="/constructor" element={<ProtectedRoute><Constructor /></ProtectedRoute>} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPostPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<About />} />
        <Route path="/saved" element={<SavedPractices />} />
        <Route path="/onlineClub" element={<OnlineClubPage />} />
        <Route path="/live" element={<ProtectedRoute><Live /></ProtectedRoute>} />
        <Route path="/successfulPayment" element={<SuccessfulPayment />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/unsubscribeSuccess" element={<UnsubscribeSuccess />} />
        <Route path="/membersOnly" element={<MembersOnly />} />
        <Route path="/" element={<Library />} />
        <Route path="/callback" element={<Callback />} />
      </Routes>
      {/* //todo uncomment and implement chat */}
      {/* <button
        onClick={() => setIsChatOpen(true)}
        className="fixed bg-beige hover:bg-brown text-white p-3 rounded-full shadow-lg z-50"
        style={{ bottom: '20px', right: '20px' }}
      >
        {ChatbotTrans[language].chatbot}
      </button> */}
      {/* <ChatbotModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} /> */}
      {toaster.show && (
        <Toaster
          message={toaster.message}
          type={toaster.type}
          onClose={() => setToaster({ ...toaster, show: false })}
        />
      )}
      {/* Uncomment the Footer if needed */}
      <Footer />
    </div>
  );
}

export default App;
